import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class InventoryCounts_ds_get_inventory_count_disrepancy_summaryService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList($inParams: { inventoryCountIds: number[], $top?: number, $skip?: number }): Promise<{ result?: { InventoryCountId?: number, TotalDiscrepancies?: number, ResolvedDiscrepancies?: number }[], totalCount?: number }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.inventoryCountIds)) {
      $missingRequiredInParams.push('\'inventoryCountIds\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      inventoryCountIds: number[]    }) {
        if(isNil($inParams.inventoryCountIds)) {
          return true; 
        }
      return false;
    }
}
